import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19368 18896"
    {...props}
  >
    <path
      d="M17228 14986c-2638-1936-4024-3353-4106-4512 773 24 1813 235 3147 607-1369-382-2393-748-3087-1135 363-1189 2303-2117 5909-3123-3348 935-5406 1160-6356 464 480-553 1224-1182 2229-1921-1026 754-1867 1288-2552 1590-707-1023-150-3156 1459-6679-1555 3406-2772 5205-3970 5400-152-705-217-1650-217-2854 0 1204-65 2149-218 2854-1197-195-2414-1994-3969-5400 1609 3523 2166 5656 1459 6679-686-302-1526-836-2553-1590 1006 739 1749 1369 2230 1921-951 696-3008 471-6356-464 3606 1006 5546 1934 5908 3123-693 387-1717 753-3086 1135 1333-372 2373-583 3146-607-82 1159-1468 2576-4105 4512 2797-2053 4631-2968 5791-2610-140 808-541 1892-1178 3287 629-1378 1179-2377 1693-3005 908 750 1238 2693 1238 5961 0-3268 329-5211 1238-5961 514 627 1063 1627 1692 3005-637-1395-1038-2479-1177-3287 1159-359 2994 557 5791 2610z"
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 553.359,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
